
class VWidget {

    constructor() {
        this.supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
        this.listSections = document.querySelectorAll('.homepage-catlist');
        this.isMobile = window.matchMedia('(max-width:767px)').matches;
        this.listing = document.querySelector('ul.newused-listing');
        if (!this.listing) {
            return;
        }
        this.delay = 5000; /* the scroller timeout */
        this.scrollCancel = false; /* this is a flag we'll use when buttons are clicked to prevent it running */
        this.setIE();
        this.setObserver();
        this.doObserve();
        this.setLazyObserver();
        this.setButtonScroll();
        this.setScrollObserver();
      //  this.setAutoScroll(10000); /*set delay in milliseconds here */



    }

    setIE() {
        if (this.listing) {
        /* for "old" Edge and below we need explictly set the number of columns, which will vary so we'll get the number of child elements. */
        const isLegacy = window.getComputedStyle(this.listing).display === '-ms-grid';
        if (!isLegacy) {
            return;
        }
        const _kids = this.listing.children.length;
        let msStyle = `-ms-grid-columns:( calc(-10px + 33%) 20px )[${_kids}]`;
        this.listing.setAttribute('style',msStyle);
    }
    }

    setObserver() {

        if (typeof IntersectionObserver !== 'undefined') {
            this.observer = new IntersectionObserver(e => {
                e.map(entry => {
                    const { isIntersecting, intersectionRatio } = entry;
                    if (!entry.target.previousElementSibling) {
                        /* this is the first element */
                        if (isIntersecting === true) {
                            document.querySelector('.btn-prev').style.visibility = 'hidden';

                        } else {
                            document.querySelector('.btn-prev').style.visibility = 'visible';
                        }

                    } else if (!entry.target.nextElementSibling) {

                        if (isIntersecting === true) {
                            document.querySelector('.btn-next').style.visibility = 'hidden';
                            clearTimeout(this.scrollTimer); /* if we've scrolled here automatically then stop the autoscroll function */

                        } else {

                            document.querySelector('.btn-next').style.visibility = 'visible';
                        }

                    }

                });

            });
        }

    }

    doObserve() {
       
        if (!this.listing || !this.observer) {
            return;
        }
        const vElements = this.listing.children;
        const vLength = vElements.length;
        let first = vElements[0];
        let last = vElements[vLength - 1];
        this.observer.observe(first);
        this.observer.observe(last);

    }
    
    setButtonScroll() {
if (!this.listing) {return;}
        const _nav = document.querySelectorAll('section.newused-widget nav a');
        const maxIdx = this.listing.children.length -1;
        let _targetIdx = 0;
        let rect = 0;
        let scrollType = this.listing.dataset.scrolltype;
        let dir = "f";
        [..._nav].map(n=>{
                n.addEventListener('click',e=>{
                    
                    if (e.target.classList.contains('btn-next')) {
                        _targetIdx = (_targetIdx < maxIdx) ? _targetIdx + 1 : _targetIdx;
                        rect = (scrollType) ? (this.listing.scrollLeft + this.listing.offsetWidth) : this.listing.children[_targetIdx].offsetLeft;
                        dir = "f"

                    } else {
                        _targetIdx = (_targetIdx > 0) ? _targetIdx - 1 : 0;
                        rect = (scrollType) ? (this.listing.scrollLeft - this.listing.offsetWidth) : this.listing.children[_targetIdx].offsetLeft;
                        dir = "r";
                    }

                    if (this.supportsNativeSmoothScroll) {
                        this.listing.scrollTo({left: rect, top: 0, behavior: 'smooth'});
                          
                    } else {

                        this.doPseudoScrollTo(this.listing, rect, scrollType, dir);

                    }

                });

                n.addEventListener('mouseup',()=>{
                    this.scrollCancel = true;
                    clearTimeout(this.scrollTimer);
                   

                });
        });

    }

     /* some browsers can't handle scrollTo options so we'll recreate the smooth function here */
     doPseudoScrollTo(el, pos, s, d) {

        let gapInt = (this.isMobile) ? 10 : 20;
        let diff = (d === 'f') ? gapInt : -(gapInt); /* 20px is the CSS grid gap setting. Adjust this to suit */
        let lPos = (s) ? pos + diff : pos;
        jQuery(el).animate({scrollLeft: lPos}, 'slow');
    }


    /**
     * Observe any "lazy" elements and load the content as they come into view
     */
    setLazyObserver() {
        if (!this.listing) {return;}

        const lazylist = this.listing.querySelectorAll('.lazy');
        const apiUrl = "/api/vehicle/fetch";
        if (typeof IntersectionObserver !== 'undefined') {
            this.lazyobserver = new IntersectionObserver(e => {
                e.map(entry => {
                    const { isIntersecting, intersectionRatio } = entry;
                if (isIntersecting === true) {
                    let url = `${apiUrl}/${entry.target.dataset.vid}`;
                    fetch(url)
                    .then(response=>{
                        return response.text();
                    })
                    .then(html=> {entry.target.innerHTML = html;
                        entry.target.classList.remove('lazy')
                        this.lazyobserver.unobserve(entry.target)});/* unobserve the element once we're loaded */
                }
                });
           
            },{threshold:0.1,rootMargin:'0%'});

            [...lazylist].map(l=>{
                this.lazyobserver.observe(l);

            });

        } 
        }

        setScrollObserver() {
            if (!this.listing) {return;}
            
            if (typeof IntersectionObserver !== 'undefined') {

                    this.scrollobserve = new IntersectionObserver(s=> {
                        s.map(e => {
                       const {isIntersecting, intersectionRatio} = e;
                       if (isIntersecting === true) {
                           setTimeout(()=> {
                            this.setAutoScroll(this.delay);


                           },this.delay);
                
                        this.scrollobserve.unobserve(e.target); /* once it's running we'll leave it alone */

                       }

                    });

                   
                });

                this.scrollobserve.observe(this.listing);

            }

        }


       setAutoScroll(delay) {
          if (!this.scrollCancel) {
        clearTimeout(this.scrollTimer);
        document.querySelector('.btn-next').click();
        this.scrollTimer = setTimeout(()=>{
            this.setAutoScroll(delay);

        },delay);
    
    }
       }

}

window.addEventListener('load', () => {
    new VWidget;


});